// import axios from "axios";
// import { useState, useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import "../../assets/css/Loader.css";
// import ApiUrl from "./../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";

// function SalesExpense() {
//   const [responseData, setResponseData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [deleteShowModals, setDeleteShowModals] = useState(false);
//   const [actionType, setActionType] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [notifications, setNotifications] = useState([]);
//   const [selectedRecordId, setSelectedRecordId] = useState(null);
//   const [deleteId, setDeleteId] = useState("");
//   const [deleteDate, setDeleteDate] = useState("");
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showAllItems, setShowAllItems] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isLoading, setIsLoading] = useState(true);
//   const [selectedManagerFilter, setSelectedManagerFilter] = useState("");
//   const [allManagers, setAllManagers] = useState([]);

//   // Helper function to format date to DD-MM-YYYY for display
//   const formatDateDisplay = (dateString) => {
//     if (!dateString) return "";
//     try {
//       if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
//         return dateString;
//       }
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) return dateString;
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (error) {
//       return dateString;
//     }
//   };

//   // Helper function to normalize date for comparison (YYYY-MM-DD)
//   const normalizeDateForComparison = (dateString) => {
//     if (!dateString) return "";
//     if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
//       return dateString;
//     }
//     if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
//       const parts = dateString.split('-');
//       return `${parts[2]}-${parts[1]}-${parts[0]}`;
//     }
//     try {
//       const date = new Date(dateString);
//       if (!isNaN(date.getTime())) {
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, "0");
//         const day = String(date.getDate()).padStart(2, "0");
//         return `${year}-${month}-${day}`;
//       }
//     } catch (e) {
//       // Ignore
//     }
//     return dateString;
//   };

//   // Fetch notifications
//   const fetchNotifications = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/notification.php`);
//       setNotifications(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching notifications:", error.message);
//     }
//   };

//   const checkNotificationStatus = (recordId, buttonValue) => {
//     const userId = localStorage.getItem("username");
//     return notifications.some(
//       (notif) =>
//         notif.table_id === recordId.toString() &&
//         notif.button_value === buttonValue &&
//         notif.status === "accepted" &&
//         notif.employe_id === userId &&
//         notif.viewed === "false"
//     );
//   };

//   const hasPendingNotification = (recordId, buttonValue) => {
//     const userId = localStorage.getItem("username");
//     return notifications.some(
//       (notif) =>
//         notif.table_id === recordId.toString() &&
//         notif.button_value === buttonValue &&
//         notif.status === "requested" &&
//         notif.employe_id === userId &&
//         notif.viewed === "false"
//     );
//   };

//   const handleNotificationSubmit = async (e) => {
//     e.preventDefault();
//     e.stopPropagation();

//     if (isSubmitting) return;
//     setIsSubmitting(true);

//     if (hasPendingNotification(selectedRecordId, actionType)) {
//       toast.warning(
//         "A pending request for this action already exists!",
//         3000,
//         "topRight"
//       );
//       closeNotificationModal();
//       return;
//     }

//     try {
//       const userId = localStorage.getItem("username");
//       const currentTime = new Date()
//         .toISOString()
//         .slice(0, 19)
//         .replace("T", " ");

//       const formData = {
//         table_name: "sales_vs_expense",
//         table_id: selectedRecordId,
//         employe_id: userId || "",
//         status: "requested",
//         button_value: actionType,
//         time: currentTime,
//         viewed: "false",
//         created_date: currentTime,
//         updated_by: userId || "",
//         updated_date: currentTime,
//       };

//       await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
//         headers: { "Content-Type": "application/json" },
//       });

//       toast.success(
//         `${actionType} request sent successfully!`,
//         3000,
//         "topRight"
//       );
//       closeNotificationModal();
//       fetchNotifications();
//     } catch (error) {
//       console.error("Error submitting notification:", error.message);
//       toast.error(
//         `Error submitting notification: ${error.message}`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const openNotificationModal = (id, action) => {
//     setSelectedRecordId(id);
//     setActionType(action);
//     setShowModal(true);
//   };

//   const closeNotificationModal = () => {
//     setShowModal(false);
//     setSelectedRecordId(null);
//     setActionType("");
//     setIsSubmitting(false);
//   };

//   const handleCloseModal = () => {
//     setDeleteShowModals(false);
//     setDeleteId("");
//     setDeleteDate("");
//   };

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const localRole = localStorage.getItem("role");
//       const localUsername = localStorage.getItem("username");

//       const params = new URLSearchParams();
//       if (localRole === "Employee") params.set("employee_id", localUsername);
//       // Scope Sales figures to the selected manager server-side, so the totals
//       // shown are that manager's actual sales for the day (Expense stays shop-wide).
//       if (selectedManagerFilter) params.set("manager", selectedManagerFilter);

//       const url = `${ApiUrl}/Api/sales_vs_expense.php${
//         params.toString() ? `?${params.toString()}` : ""
//       }`;

//       const response = await axios.get(url);
//       console.log("Sales vs Expense API Response:", response.data);

//       const data = response.data?.data || [];
//       setResponseData([...data].reverse());
//       if (Array.isArray(response.data?.managers)) {
//         setAllManagers(response.data.managers);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setResponseData([]);
//       toast.error(`Failed to fetch data: ${error.message}`, 3000, "topRight");
//     } finally {
//       setTimeout(() => {
//         setLoading(false);
//         setIsLoading(false);
//       }, 500);
//     }
//   };

//   // ── NEW: tells the layout/sidebar to collapse before we navigate away
//   // to the transaction-overview page. The Sidebar itself doesn't own this
//   // state (its parent Layout does via the `collapsed`/`toggleSidebar` props),
//   // so we broadcast an event + set a flag the Layout can read on mount.
//   // See the snippet at the end of this file for the one-line listener
//   // your Layout component needs to add.
//   const collapseSidebarForNavigation = () => {
//     try {
//       localStorage.setItem("sidebarCollapsed", "true");
//       window.dispatchEvent(new CustomEvent("app:collapseSidebar"));
//     } catch (e) {
//       // no-op if storage/events are unavailable
//     }
//   };

//   // Handle edit / view action — now also carries the manager name through
//   // to the transaction-overview page (via router state + query param, so
//   // the destination page can pick whichever it finds convenient) and
//   // collapses the sidebar.
//   const handleEdit = (id, date, manager) => {
//     const userRole = localStorage.getItem("role");
//     const normalizedDate = normalizeDateForComparison(date);

//     collapseSidebarForNavigation();

//     const managerQuery = manager
//       ? `?manager=${encodeURIComponent(manager)}`
//       : "";
//     const destination = `/add-sales-vs-expense/${normalizedDate}${managerQuery}`;

//     // if (userRole === "Employee") {
//     if (userRole === "Employee" || userRole === "Manager") {
//       if (checkNotificationStatus(id, "Edit")) {
//         navigate(destination, { state: { manager: manager || null } });
//       } else {
//         openNotificationModal(id, "Edit");
//       }
//     } else {
//       navigate(destination, { state: { manager: manager || null } });
//     }
//   };

//   const handleOpenDeleteModal = (id, date) => {
//     const userRole = localStorage.getItem("role");
//     const displayDate = formatDateDisplay(date);

//     // if (userRole === "Employee") {
//     if (userRole === "Employee" || userRole === "Manager") {
//       if (checkNotificationStatus(id, "Delete")) {
//         setDeleteId(id);
//         setDeleteDate(displayDate);
//         setDeleteShowModals(true);
//       } else {
//         openNotificationModal(id, "Delete");
//       }
//     } else {
//       setDeleteId(id);
//       setDeleteDate(displayDate);
//       setDeleteShowModals(true);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.delete(
//         `${ApiUrl}/Api/sales_vs_expense.php/${deleteId}`
//       );

//       if (response.data.status) {
//         const notification = notifications.find(
//           (notif) =>
//             notif.table_id === deleteId.toString() &&
//             notif.button_value === "Delete" &&
//             notif.viewed === "false"
//         );

//         if (notification) {
//           const currentTime = new Date()
//             .toISOString()
//             .slice(0, 19)
//             .replace("T", " ");
//           const notificationPayload = {
//             id: notification.id,
//             viewed: "true",
//             updated_by: localStorage.getItem("username"),
//             updated_date: currentTime,
//             table_name: notification.table_name,
//             table_id: notification.table_id,
//             employe_id: notification.employe_id,
//             status: notification.status,
//             button_value: notification.button_value,
//             time: notification.time,
//             created_date: notification.created_date,
//           };

//           await axios.put(
//             `${ApiUrl}/Api/notification.php/${notification.id}`,
//             notificationPayload,
//             {
//               headers: { "Content-Type": "application/json" },
//             }
//           );
//         }

//         toast.success("Deleted successfully!", 3000, "topRight");
//         handleCloseModal();
//         fetchData();
//         fetchNotifications();
//       } else {
//         toast.error(response.data.message || "Failed to delete", 3000, "topRight");
//       }
//     } catch (error) {
//       console.error("Error deleting data:", error.message);
//       toast.error(`Failed to delete data: ${error.message}`, 3000, "topRight");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Manager scoping now happens server-side (see fetchData), so this just
//   // handles the free-text search on top of whatever the API already returned.
//   const filteredData = useMemo(() => {
//     return responseData.filter((item) => {
//       const searchLower = searchTerm.toLowerCase();
//       return (
//         !searchTerm.trim() || (
//           formatDateDisplay(item.date).toLowerCase().includes(searchLower) ||
//           (item.sales_total || "0").toString().toLowerCase().includes(searchLower) ||
//           (item.expense_total || "0").toString().toLowerCase().includes(searchLower) ||
//           (item.manager || "").toLowerCase().includes(searchLower) ||
//           (item.weight || "0").toString().toLowerCase().includes(searchLower)
//         )
//       );
//     });
//   }, [responseData, searchTerm]);

//   // Prefer the full manager list from the API (covers every manager, not just
//   // whoever happened to be first on a given day); fall back to whatever's
//   // visible in the currently loaded rows.
//   const uniqueManagers = useMemo(() => {
//     if (allManagers.length > 0) return allManagers;
//     const managers = responseData
//       .map((item) => item.manager)
//       .filter((m) => m && m.trim() !== "");
//     return [...new Set(managers)].sort();
//   }, [allManagers, responseData]);

//   const { totalItems, totalPages, currentItems } = useMemo(() => {
//     const totalItems = filteredData.length;
//     const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
//     const currentItems = showAllItems
//       ? filteredData
//       : filteredData.slice(
//           (currentPage - 1) * itemsPerPage,
//           currentPage * itemsPerPage
//         );

//     return { totalItems, totalPages, currentItems };
//   }, [filteredData, showAllItems, currentPage, itemsPerPage]);

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const handleItemsPerPageChange = (e) => {
//     const value = e.target.value;
//     if (value === "All") {
//       setShowAllItems(true);
//       setCurrentPage(1);
//     } else {
//       setShowAllItems(false);
//       setItemsPerPage(Number(value));
//       setCurrentPage(1);
//     }
//   };

//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 2;
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     if (startPage > 1) {
//       pages.push(
//         <li
//           key={1}
//           className={`page-item ${currentPage === 1 ? "active" : ""}`}
//         >
//           <button
//             className="page-link"
//             onClick={() => handlePageChange(1)}
//             aria-label="First page"
//           >
//             1
//           </button>
//         </li>
//       );
//       if (startPage > 2) {
//         pages.push(
//           <li key="start-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <li
//           key={i}
//           className={`page-item ${currentPage === i ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(i)}>
//             {i}
//           </button>
//         </li>
//       );
//     }

//     if (endPage < totalPages) {
//       if (endPage < totalPages - 1) {
//         pages.push(
//           <li key="end-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//       pages.push(
//         <li
//           key={totalPages}
//           className={`page-item ${currentPage === totalPages ? "active" : ""}`}
//         >
//           <button
//             className="page-link"
//             onClick={() => handlePageChange(totalPages)}
//           >
//             {totalPages}
//           </button>
//         </li>
//       );
//     }

//     return pages;
//   };

//   // ── PRINT ── now includes every field visible in the on-screen table
//   // (S.No, Date, Manager, Weight, Sales Total, Expense Total) and relies
//   // on print CSS (thead repeated per page + page-break rules on <tr>) so
//   // the browser automatically spills onto a 2nd/3rd printed page instead
//   // of clipping or squeezing everything onto one page.
//   const handlePrint = () => {
//     try {
//       const printWindow = window.open("", "_blank");
//       printWindow.document.write(`
//         <html>
//         <head>
//           <title>Sales vs Expense Report</title>
//           <style>
//             @page {
//               size: A4 landscape;
//               margin: 12mm;
//             }
//             body { font-family: Arial, sans-serif; margin: 0; }
//             .header { text-align: center; margin-bottom: 10px; }
//             .meta { text-align: center; margin-bottom: 16px; font-size: 12px; color: #555; }
//             table {
//               width: 100%;
//               border-collapse: collapse;
//               table-layout: fixed;
//             }
//             /* Repeat header row on every printed page */
//             thead { display: table-header-group; }
//             tfoot { display: table-footer-group; }
//             /* Let the table split across pages, but never split a single row */
//             table { page-break-inside: auto; }
//             tr { page-break-inside: avoid; page-break-after: auto; }
//             th, td {
//               border: 1px solid #ddd;
//               padding: 6px 8px;
//               text-align: left;
//               font-size: 11px;
//               word-wrap: break-word;
//             }
//             th { background-color: #f2f2f2; font-weight: bold; }
//             .footer-note { margin-top: 12px; font-size: 11px; text-align: right; }
//           </style>
//         </head>
//         <body>
//           <div class="header"><h2>Sales vs Expense Report</h2></div>
//           <div class="meta">Generated on: ${new Date().toLocaleString()}${
//             selectedManagerFilter ? ` &mdash; Manager: ${selectedManagerFilter}` : ""
//           }</div>
//           <table>
//             <thead>
//               <tr>
//                 <th style="width:8%">S.No</th>
//                 <th style="width:18%">Date</th>
//                 <th style="width:20%">Weight (g)</th>
//                 <th style="width:27%">Sales Total</th>
//                 <th style="width:27%">Expense Total</th>
//               </tr>
//             </thead>
//             <tbody>
//               ${filteredData
//                 .map((item, index) => `
//                   <tr>
//                     <td>${index + 1}</td>
//                     <td>${formatDateDisplay(item.date) || ""}</td>
//                     <td>${item.weight || "0"} g</td>
//                     <td>&#8377; ${item.sales_total || "0"}</td>
//                     <td>&#8377; ${item.expense_total || "0"}</td>
//                   </tr>
//                 `)
//                 .join("")}
//             </tbody>
//           </table>
//           <p class="footer-note">Total Records: ${filteredData.length}</p>
//         </body>
//         </html>
//       `);
//       printWindow.document.close();
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//       toast.success("Print dialog opened!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error printing:", error.message);
//       toast.error(`Error printing: ${error.message}`, 3000, "topRight");
//     }
//   };

//   const exportPDF = () => {
//     try {
//       const doc = new jsPDF({ orientation: "landscape" });
//       doc.setFontSize(20);
//       doc.text("Sales vs Expense Report", 14, 22);
//       doc.setFontSize(12);
//       doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 32);

//       const tableColumn = ["S.No", "Date", "Weight (g)", "Sales Total", "Expense Total"];
//       const tableRows = filteredData.map((item, index) => [
//         index + 1,
//         formatDateDisplay(item.date) || "",
//         `${item.weight || "0"} g`,
//         `Rs.${item.sales_total || "0"}`,
//         `Rs.${item.expense_total || "0"}`,
//       ]);

//       autoTable(doc, {
//         head: [tableColumn],
//         body: tableRows,
//         startY: 40,
//         styles: { fontSize: 8, cellPadding: 2 },
//         headStyles: { fillColor: [41, 128, 185], textColor: 255 },
//       });

//       doc.save(
//         `sales-vs-expense-${new Date().toISOString().split("T")[0]}.pdf`
//       );
//       toast.success("PDF exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting PDF:", error.message);
//       toast.error(`Error exporting PDF: ${error.message}`, 3000, "topRight");
//     }
//   };

//   const copyToClipboard = () => {
//     try {
//       const headers = ["S.No", "Date", "Weight (g)", "Sales Total", "Expense Total"];
//       const rows = filteredData.map((item, index) => [
//         index + 1,
//         formatDateDisplay(item.date) || "",
//         item.weight || "0",
//         item.sales_total || "0",
//         item.expense_total || "0",
//       ]);

//       const formattedText = [headers, ...rows]
//         .map((row) => row.map((field) => `"${field}"`).join("\t"))
//         .join("\n");

//       navigator.clipboard
//         .writeText(formattedText)
//         .then(() => {
//           toast.success(
//             "Data copied to clipboard successfully!",
//             3000,
//             "topRight"
//           );
//         })
//         .catch((err) => {
//           console.error("Clipboard API failed:", err);
//           toast.error(`Clipboard error: ${err.message}`, 3000, "topRight");
//         });
//     } catch (error) {
//       console.error("Unexpected error copying to clipboard:", error.message);
//       toast.error(`Error copying data: ${error.message}`, 3000, "topRight");
//     }
//   };

//   const exportCSV = () => {
//     try {
//       const csvData = [
//         ["S.No", "Date", "Weight (g)", "Sales Total", "Expense Total"],
//         ...filteredData.map((item, index) => [
//           index + 1,
//           formatDateDisplay(item.date) || "",
//           item.weight || "0",
//           item.sales_total || "0",
//           item.expense_total || "0",
//         ]),
//       ];

//       const csvContent = csvData
//         .map((row) => row.map((field) => `"${field}"`).join(","))
//         .join("\n");

//       const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//       const link = document.createElement("a");
//       const url = URL.createObjectURL(blob);
//       link.setAttribute("href", url);
//       link.setAttribute(
//         "download",
//         `sales-vs-expense-${new Date().toISOString().split("T")[0]}.csv`
//       );
//       link.style.visibility = "hidden";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       toast.success("CSV file exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting CSV:", error.message);
//       toast.error(`Error exporting CSV: ${error.message}`, 3000, "topRight");
//     }
//   };

//   const exportExcel = () => {
//     try {
//       const excelData = filteredData.map((item, index) => ({
//         "S.No": index + 1,
//         Date: formatDateDisplay(item.date) || "",
//         "Weight (g)": item.weight || "0",
//         "Sales Total": item.sales_total || "0",
//         "Expense Total": item.expense_total || "0",
//       }));

//       const ws = XLSX.utils.json_to_sheet(excelData);
//       const colWidths = [{ wch: 8 }, { wch: 15 }, { wch: 12 }, { wch: 15 }, { wch: 15 }];
//       ws["!cols"] = colWidths;
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Sales vs Expense");
//       XLSX.writeFile(
//         wb,
//         `sales-vs-expense-${new Date().toISOString().split("T")[0]}.xlsx`
//       );
//       toast.success("Excel file exported successfully!", 3000, "topRight");
//     } catch (error) {
//       console.error("Error exporting Excel:", error.message);
//       toast.error(`Error exporting Excel: ${error.message}`, 3000, "topRight");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     fetchNotifications();

//     const interval = setInterval(() => {
//       if (document.visibilityState === "visible") {
//         fetchData();
//         fetchNotifications();
//       }
//     }, 30000);

//     return () => clearInterval(interval);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedManagerFilter]);

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}
//       <div className="container-fluid">
//         <h6 className="card-title m-2">Sales Vs Expense</h6>
//         <div className="card shadow-sm mb-5">
//           <div className="card-body">
//             {selectedManagerFilter && (
//               <div className="alert alert-info py-2 px-3 mb-3" role="alert">
//                 Showing overview for manager: <strong>{selectedManagerFilter}</strong>
//               </div>
//             )}
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <div className="d-flex align-items-center gap-3">
//                 <div className="d-flex align-items-center">
//                   <label className="form-label text-dark me-2 ">Show:</label>
//                   <select
//                     className="form-control mt-2"
//                     style={{ width: "100px" }}
//                     onChange={handleItemsPerPageChange}
//                     value={showAllItems ? "All" : itemsPerPage}
//                     aria-label="Items per page"
//                   >
//                     <option value="All">All</option>
//                     {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
//                       <option key={pageSize} value={pageSize}>
//                         {pageSize}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="d-flex align-items-center">
//                   <label className="form-label text-dark me-2 ">Manager:</label>
//                   <select
//                     className="form-control mt-2"
//                     style={{ width: "150px" }}
//                     value={selectedManagerFilter}
//                     onChange={(e) => {
//                       setSelectedManagerFilter(e.target.value);
//                       setCurrentPage(1);
//                     }}
//                     aria-label="Filter by manager"
//                   >
//                     <option value="">All Managers</option>
//                     {uniqueManagers.map((manager) => (
//                       <option key={manager} value={manager}>
//                         {manager}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
//               <div className="d-flex justify-content-center">
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1 mt-2"
//                   onClick={handlePrint}
//                   aria-label="Print report"
//                 >
//                   Print
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1 mt-2"
//                   onClick={exportPDF}
//                   aria-label="Export to PDF"
//                 >
//                   PDF
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1 mt-2"
//                   onClick={copyToClipboard}
//                   aria-label="Copy to clipboard"
//                 >
//                   Copy
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1 mt-2"
//                   onClick={exportCSV}
//                   aria-label="Export to CSV"
//                 >
//                   CSV
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1 mt-2"
//                   onClick={exportExcel}
//                   aria-label="Export to Excel"
//                 >
//                   Excel
//                 </button>
//               </div>
//               <div className="search-container">
//                 <input
//                   type="text"
//                   className="form-control mt-2"
//                   placeholder="Search"
//                   aria-label="Search"
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                 />
//               </div>
//             </div>
//             <div className="card tableCard p-2">
//               <div className="table-container">
//                 {isLoading ? (
//                   <div className="text-center p-4">Loading...</div>
//                 ) : (
//                   <table className="table table-layout-fixed w-100">
//                     <thead className="bg-light">
//                       <tr>
//                         <th scope="col">S.No</th>
//                         <th scope="col">Date</th>
//                         {/* <th scope="col">Weight (g)</th> */}
//                         <th scope="col">Sales Total</th>
//                         <th scope="col">Expense Total</th>
//                         <th scope="col">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {currentItems.length > 0 ? (
//                         currentItems.map((item, index) => {
//                           const userId = localStorage.getItem("username");
//                           const notification = notifications.find(
//                             (notif) =>
//                               notif.table_id === item.id?.toString() &&
//                               notif.employe_id === userId &&
//                               notif.viewed === "false" &&
//                               ["Edit", "Delete"].includes(notif.button_value)
//                           );

//                           let rowClass = "";
//                           if (notification) {
//                             switch (notification.status) {
//                               case "accepted":
//                                 rowClass = "table-secondary";
//                                 break;
//                               case "rejected":
//                                 rowClass = "table-danger";
//                                 break;
//                               case "requested":
//                                 rowClass = "table-info";
//                                 break;
//                             }
//                           }

//                           return (
//                             <tr key={item.id || index} className={rowClass}>
//                               <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                               <td>{formatDateDisplay(item.date)}</td>
//                               {/* <td>{item.weight || "0"} g</td> */}
//                               <td>₹ {item.sales_total || "0"}</td>
//                               <td>₹ {item.expense_total || "0"}</td>
//                               <td>
//                                 <button
//                                   className="btn btn-light btn-sm mx-1"
//                                   onClick={() => handleEdit(item.id, item.date, item.manager)}
//                                 >
//                                   <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           );
//                         })
//                       ) : (
//                         <tr>
//                           <td colSpan="6" className="text-center">
//                             No data available
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 )}
//               </div>
//               <div className="row mt-3">
//                 <div className="col-lg-6">
//                   <p className="text-muted">
//                     Showing{" "}
//                     {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
//                     {showAllItems
//                       ? totalItems
//                       : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
//                     of {totalItems} entries
//                   </p>
//                 </div>
//                 <div className="col-lg-6">
//                   <nav aria-label="Page navigation">
//                     <ul className="pagination justify-content-end">
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(1)}
//                           aria-label="First page"
//                         >
//                           <span aria-hidden="true">««</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           aria-label="Previous page"
//                         >
//                           <span aria-hidden="true">«</span>
//                         </button>
//                       </li>
//                       {renderPageNumbers()}
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           aria-label="Next page"
//                         >
//                           <span aria-hidden="true">»</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(totalPages)}
//                           aria-label="Last page"
//                         >
//                           <span aria-hidden="true">»»</span>
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* Notification Modal */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="notificationModalLabel"
//         aria-hidden={!showModal}
//         role="dialog"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="notificationModalLabel"
//               >
//                 Send {actionType} Request to Admin
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={closeNotificationModal}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <form onSubmit={handleNotificationSubmit}>
//                 <p className="text-center">
//                   Do you want to request to {actionType.toLowerCase()} this
//                   record?
//                 </p>
//                 <div className="text-center mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-secondary btn-sm px-4 me-2"
//                     onClick={closeNotificationModal}
//                     aria-label="Cancel"
//                   >
//                     No
//                   </button>
//                   <button
//                     type="submit"
//                     className="btn btn-primary btn-sm px-4"
//                     disabled={isSubmitting}
//                     aria-label="Submit request"
//                   >
//                     Yes
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* Delete Confirmation Modal */}
//       <div
//         className={`modal fade ${deleteShowModals ? "show" : ""}`}
//         style={{ display: deleteShowModals ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="deleteConfirmModalLabel"
//         aria-hidden={!deleteShowModals}
//         role="dialog"
//       >
//         <div className="modal-dialog modal-dialog-centered modal-confirm">
//           <div className="modal-content">
//             <div className="modal-body text-center">
//               <div className="d-flex justify-content-center mb-3">
//                 <div
//                   className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
//                   style={{ width: "80px", height: "80px" }}
//                 >
//                   <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                 </div>
//               </div>
//               <h4 className="modal-title mb-3">Are you sure?</h4>
//               <h6 className="mb-4">
//                 Do you really want to delete the record for
//                 <span className="text-primary"> {deleteDate}</span>?
//               </h6>
//               <div className="d-flex btn-group">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm flex-grow-1"
//                   onClick={handleCloseModal}
//                   aria-label="Cancel"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger btn-sm flex-grow-1 mx-2"
//                   onClick={handleDelete}
//                   aria-label="Delete"
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default SalesExpense;

// /*
//   ── ONE-LINE ADDITION NEEDED IN YOUR LAYOUT COMPONENT ──
//   Wherever `collapsed`/`toggleSidebar` state lives (the component that
//   renders <Sidebar collapsed={...} toggleSidebar={...} .../>), add:

//   useEffect(() => {
//     const onCollapse = () => setCollapsed(true); // your state setter
//     window.addEventListener("app:collapseSidebar", onCollapse);
//     return () => window.removeEventListener("app:collapseSidebar", onCollapse);
//   }, []);

//   That's it — SalesExpense now fires this event right before navigating
//   to the txn-overview page, so the sidebar will already be collapsed
//   when the new page mounts.
// */


import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/Loader.css";
import ApiUrl from "./../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function SalesExpense() {
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [deleteId, setDeleteId] = useState("");
  const [deleteDate, setDeleteDate] = useState("");
  const navigate = useNavigate();
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // Helper function to format date to DD-MM-YYYY for display
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    try {
      if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
        return dateString;
      }
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Helper function to normalize date for comparison (YYYY-MM-DD)
  const normalizeDateForComparison = (dateString) => {
    if (!dateString) return "";
    if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return dateString;
    }
    if (dateString.match(/^\d{2}-\d{2}-\d{4}$/)) {
      const parts = dateString.split('-');
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    try {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
    } catch (e) {
      // Ignore
    }
    return dateString;
  };

  // Fetch notifications
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
    }
  };

  const checkNotificationStatus = (recordId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === recordId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const hasPendingNotification = (recordId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === recordId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedRecordId, actionType)) {
      toast.warning(
        "A pending request for this action already exists!",
        3000,
        "topRight"
      );
      closeNotificationModal();
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "sales_vs_expense",
        table_id: selectedRecordId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        `${actionType} request sent successfully!`,
        3000,
        "topRight"
      );
      closeNotificationModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error(
        `Error submitting notification: ${error.message}`,
        3000,
        "topRight"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const openNotificationModal = (id, action) => {
    setSelectedRecordId(id);
    setActionType(action);
    setShowModal(true);
  };

  const closeNotificationModal = () => {
    setShowModal(false);
    setSelectedRecordId(null);
    setActionType("");
    setIsSubmitting(false);
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setDeleteId("");
    setDeleteDate("");
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const localRole = localStorage.getItem("role");
      const localUsername = localStorage.getItem("username");

      const params = new URLSearchParams();
      if (localRole === "Employee") params.set("employee_id", localUsername);

      const url = `${ApiUrl}/Api/sales_vs_expense.php${
        params.toString() ? `?${params.toString()}` : ""
      }`;

      // No manager param here — the API now automatically returns one row
      // per manager for each date that had multiple managers billing.
      const response = await axios.get(url);
      console.log("Sales vs Expense API Response:", response.data);

      const data = response.data?.data || [];
      setResponseData([...data].reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setResponseData([]);
      toast.error(`Failed to fetch data: ${error.message}`, 3000, "topRight");
    } finally {
      setTimeout(() => {
        setLoading(false);
        setIsLoading(false);
      }, 500);
    }
  };

  // ── NEW: tells the layout/sidebar to collapse before we navigate away
  // to the transaction-overview page. The Sidebar itself doesn't own this
  // state (its parent Layout does via the `collapsed`/`toggleSidebar` props),
  // so we broadcast an event + set a flag the Layout can read on mount.
  // See the snippet at the end of this file for the one-line listener
  // your Layout component needs to add.
  const collapseSidebarForNavigation = () => {
    try {
      localStorage.setItem("sidebarCollapsed", "true");
      window.dispatchEvent(new CustomEvent("app:collapseSidebar"));
    } catch (e) {
      // no-op if storage/events are unavailable
    }
  };

  // Handle edit / view action — now also carries the manager name through
  // to the transaction-overview page (via router state + query param, so
  // the destination page can pick whichever it finds convenient) and
  // collapses the sidebar.
  const handleEdit = (id, date, manager) => {
    const userRole = localStorage.getItem("role");
    const normalizedDate = normalizeDateForComparison(date);

    collapseSidebarForNavigation();

    const managerQuery = manager
      ? `?manager=${encodeURIComponent(manager)}`
      : "";
    const destination = `/add-sales-vs-expense/${normalizedDate}${managerQuery}`;

    // if (userRole === "Employee") {
    if (userRole === "Employee" || userRole === "Manager") {
      if (checkNotificationStatus(id, "Edit")) {
        navigate(destination, { state: { manager: manager || null } });
      } else {
        openNotificationModal(id, "Edit");
      }
    } else {
      navigate(destination, { state: { manager: manager || null } });
    }
  };

  const handleOpenDeleteModal = (id, date) => {
    const userRole = localStorage.getItem("role");
    const displayDate = formatDateDisplay(date);

    // if (userRole === "Employee") {
    if (userRole === "Employee" || userRole === "Manager") {
      if (checkNotificationStatus(id, "Delete")) {
        setDeleteId(id);
        setDeleteDate(displayDate);
        setDeleteShowModals(true);
      } else {
        openNotificationModal(id, "Delete");
      }
    } else {
      setDeleteId(id);
      setDeleteDate(displayDate);
      setDeleteShowModals(true);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${ApiUrl}/Api/sales_vs_expense.php/${deleteId}`
      );

      if (response.data.status) {
        const notification = notifications.find(
          (notif) =>
            notif.table_id === deleteId.toString() &&
            notif.button_value === "Delete" &&
            notif.viewed === "false"
        );

        if (notification) {
          const currentTime = new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          const notificationPayload = {
            id: notification.id,
            viewed: "true",
            updated_by: localStorage.getItem("username"),
            updated_date: currentTime,
            table_name: notification.table_name,
            table_id: notification.table_id,
            employe_id: notification.employe_id,
            status: notification.status,
            button_value: notification.button_value,
            time: notification.time,
            created_date: notification.created_date,
          };

          await axios.put(
            `${ApiUrl}/Api/notification.php/${notification.id}`,
            notificationPayload,
            {
              headers: { "Content-Type": "application/json" },
            }
          );
        }

        toast.success("Deleted successfully!", 3000, "topRight");
        handleCloseModal();
        fetchData();
        fetchNotifications();
      } else {
        toast.error(response.data.message || "Failed to delete", 3000, "topRight");
      }
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error(`Failed to delete data: ${error.message}`, 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Manager scoping now happens server-side (see fetchData), so this just
  // handles the free-text search on top of whatever the API already returned.
  const filteredData = useMemo(() => {
    return responseData.filter((item) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        !searchTerm.trim() || (
          formatDateDisplay(item.date).toLowerCase().includes(searchLower) ||
          (item.sales_total || "0").toString().toLowerCase().includes(searchLower) ||
          (item.expense_total || "0").toString().toLowerCase().includes(searchLower) ||
          (item.manager || "").toLowerCase().includes(searchLower) ||
          (item.weight || "0").toString().toLowerCase().includes(searchLower)
        )
      );
    });
  }, [responseData, searchTerm]);

  // Group the flat rows (one per manager per date, from the API) into one
  // group per date, so the table can show S.No/Date once per date and a
  // sub-row per manager underneath it.
  const dateGroups = useMemo(() => {
    const map = new Map();
    filteredData.forEach((item) => {
      const key = item.date;
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(item);
    });
    return Array.from(map.entries()).map(([date, rows]) => ({ date, rows }));
  }, [filteredData]);

  const { totalItems, totalPages, currentItems } = useMemo(() => {
    const totalItems = dateGroups.length;
    const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
    const currentItems = showAllItems
      ? dateGroups
      : dateGroups.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        );

    return { totalItems, totalPages, currentItems };
  }, [dateGroups, showAllItems, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(1)}
            aria-label="First page"
          >
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // ── PRINT ── now includes every field visible in the on-screen table
  // (S.No, Date, Manager, Weight, Sales Total, Expense Total) and relies
  // on print CSS (thead repeated per page + page-break rules on <tr>) so
  // the browser automatically spills onto a 2nd/3rd printed page instead
  // of clipping or squeezing everything onto one page.
  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
        <head>
          <title>Sales vs Expense Report</title>
          <style>
            @page {
              size: A4 landscape;
              margin: 12mm;
            }
            body { font-family: Arial, sans-serif; margin: 0; }
            .header { text-align: center; margin-bottom: 10px; }
            .meta { text-align: center; margin-bottom: 16px; font-size: 12px; color: #555; }
            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
            }
            /* Repeat header row on every printed page */
            thead { display: table-header-group; }
            tfoot { display: table-footer-group; }
            /* Let the table split across pages, but never split a single row */
            table { page-break-inside: auto; }
            tr { page-break-inside: avoid; page-break-after: auto; }
            th, td {
              border: 1px solid #ddd;
              padding: 6px 8px;
              text-align: left;
              font-size: 11px;
              word-wrap: break-word;
            }
            th { background-color: #f2f2f2; font-weight: bold; }
            .footer-note { margin-top: 12px; font-size: 11px; text-align: right; }
          </style>
        </head>
        <body>
          <div class="header"><h2>Sales vs Expense Report</h2></div>
          <div class="meta">Generated on: ${new Date().toLocaleString()}</div>
          <table>
            <thead>
              <tr>
                <th style="width:8%">S.No</th>
                <th style="width:16%">Date</th>
                <th style="width:18%">Manager</th>
                <th style="width:19%">Sales Total</th>
                <th style="width:19%">Expense Total</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData
                .map((item, index) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${formatDateDisplay(item.date) || ""}</td>
                    <td>${item.manager || "-"}</td>
                    <td>&#8377; ${item.sales_total || "0"}</td>
                    <td>&#8377; ${item.expense_total || "0"}</td>
                  </tr>
                `)
                .join("")}
            </tbody>
          </table>
          <p class="footer-note">Total Records: ${filteredData.length}</p>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error.message);
      toast.error(`Error printing: ${error.message}`, 3000, "topRight");
    }
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF({ orientation: "landscape" });
      doc.setFontSize(20);
      doc.text("Sales vs Expense Report", 14, 22);
      doc.setFontSize(12);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 32);

      const tableColumn = ["S.No", "Date", "Manager", "Sales Total", "Expense Total"];
      const tableRows = filteredData.map((item, index) => [
        index + 1,
        formatDateDisplay(item.date) || "",
        item.manager || "-",
        `Rs.${item.sales_total || "0"}`,
        `Rs.${item.expense_total || "0"}`,
      ]);

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 40,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      });

      doc.save(
        `sales-vs-expense-${new Date().toISOString().split("T")[0]}.pdf`
      );
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error.message);
      toast.error(`Error exporting PDF: ${error.message}`, 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const headers = ["S.No", "Date", "Manager", "Sales Total", "Expense Total"];
      const rows = filteredData.map((item, index) => [
        index + 1,
        formatDateDisplay(item.date) || "",
        item.manager || "-",
        item.sales_total || "0",
        item.expense_total || "0",
      ]);

      const formattedText = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      navigator.clipboard
        .writeText(formattedText)
        .then(() => {
          toast.success(
            "Data copied to clipboard successfully!",
            3000,
            "topRight"
          );
        })
        .catch((err) => {
          console.error("Clipboard API failed:", err);
          toast.error(`Clipboard error: ${err.message}`, 3000, "topRight");
        });
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error.message);
      toast.error(`Error copying data: ${error.message}`, 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const csvData = [
        ["S.No", "Date", "Manager", "Sales Total", "Expense Total"],
        ...filteredData.map((item, index) => [
          index + 1,
          formatDateDisplay(item.date) || "",
          item.manager || "-",
          item.sales_total || "0",
          item.expense_total || "0",
        ]),
      ];

      const csvContent = csvData
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `sales-vs-expense-${new Date().toISOString().split("T")[0]}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error.message);
      toast.error(`Error exporting CSV: ${error.message}`, 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const excelData = filteredData.map((item, index) => ({
        "S.No": index + 1,
        Date: formatDateDisplay(item.date) || "",
        Manager: item.manager || "-",
        "Sales Total": item.sales_total || "0",
        "Expense Total": item.expense_total || "0",
      }));

      const ws = XLSX.utils.json_to_sheet(excelData);
      const colWidths = [{ wch: 8 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
      ws["!cols"] = colWidths;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sales vs Expense");
      XLSX.writeFile(
        wb,
        `sales-vs-expense-${new Date().toISOString().split("T")[0]}.xlsx`
      );
      toast.success("Excel file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error.message);
      toast.error(`Error exporting Excel: ${error.message}`, 3000, "topRight");
    }
  };

  useEffect(() => {
    fetchData();
    fetchNotifications();

    const interval = setInterval(() => {
      if (document.visibilityState === "visible") {
        fetchData();
        fetchNotifications();
      }
    }, 30000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

const handleOverallClick = (date) => {
  const normalizedDate = normalizeDateForComparison(date);

  collapseSidebarForNavigation();

  // No manager parameter = overall shop sales & expense
  navigate(`/add-sales-vs-expense/${normalizedDate}`);
};


  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}
      <div className="container-fluid">
        <h6 className="card-title m-2">Sales Vs Expense</h6>
        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center">
                  <label className="form-label text-dark me-2 ">Show:</label>
                  <select
                    className="form-control mt-2"
                    style={{ width: "100px" }}
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                    aria-label="Items per page"
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1 mt-2"
                  onClick={handlePrint}
                  aria-label="Print report"
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1 mt-2"
                  onClick={exportPDF}
                  aria-label="Export to PDF"
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1 mt-2"
                  onClick={copyToClipboard}
                  aria-label="Copy to clipboard"
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1 mt-2"
                  onClick={exportCSV}
                  aria-label="Export to CSV"
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1 mt-2"
                  onClick={exportExcel}
                  aria-label="Export to Excel"
                >
                  Excel
                </button>
              </div>
              <div className="search-container">
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Search"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>
            <div className="card tableCard p-2">
              <div className="table-container">
                {isLoading ? (
                  <div className="text-center p-4">Loading...</div>
                ) : (
                  <table className="table table-layout-fixed w-100 sve-table">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Date</th>
                        <th scope="col">Manager</th>
                        <th scope="col">Sales Total</th>
                        <th scope="col">Expense Total</th>
                        <th scope="col">Actions</th>
                        <th scope="col">Overall</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((group, groupIndex) => {
                          const sNo = (currentPage - 1) * itemsPerPage + groupIndex + 1;
                          const userId = localStorage.getItem("username");
                          // The merged S.No/Date cell spans the whole group, so it
                          // always gets the group-end border — that's the only
                          // border it ever draws, and it should line up with the
                          // group-end border on the last manager sub-row.
                          const spanCellClass = "align-middle sve-group-end";

                          return group.rows.map((item, rowIndex) => {
                            const notification = notifications.find(
                              (notif) =>
                                notif.table_id === item.id?.toString() &&
                                notif.employe_id === userId &&
                                notif.viewed === "false" &&
                                ["Edit", "Delete"].includes(notif.button_value)
                            );

                            let rowClass = "";
                            if (notification) {
                              switch (notification.status) {
                                case "accepted":
                                  rowClass = "table-secondary";
                                  break;
                                case "rejected":
                                  rowClass = "table-danger";
                                  break;
                                case "requested":
                                  rowClass = "table-info";
                                  break;
                              }
                            }

                            const isFirstRowOfGroup = rowIndex === 0;
                            const isLastRowOfGroup = rowIndex === group.rows.length - 1;
                            const cellClass = isLastRowOfGroup ? "sve-group-end" : "sve-subrow";

                           return (
  <tr
    key={item.id || `${group.date}-${rowIndex}`}
    className={rowClass}
  >
    {isFirstRowOfGroup && (
      <>
        {/* S.No */}
        <td
          rowSpan={group.rows.length}
          className={`text-center ${spanCellClass}`}
        >
          {sNo}
        </td>

        {/* Date */}
        <td
          rowSpan={group.rows.length}
          className={spanCellClass}
        >
          {formatDateDisplay(group.date)}
        </td>
      </>
    )}

    {/* Manager */}
    <td className={cellClass}>
      {item.manager || "-"}
    </td>

    {/* Sales */}
    <td className={cellClass}>
      ₹ {item.sales_total || "0"}
    </td>

    {/* Expense */}
    <td className={cellClass}>
      ₹ {item.expense_total || "0"}
    </td>

    {/* Actions */}
    <td className={cellClass}>
      <button
        className="btn btn-light btn-sm mx-1"
        onClick={() =>
          handleEdit(item.id, item.date, item.manager)
        }
      >
        <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
      </button>
    </td>

    {/* Overall - after Actions */}
{isFirstRowOfGroup && (
  <td
    rowSpan={group.rows.length}
    className="text-center align-middle sve-group-end"
  >
    <button
      type="button"
      className="btn btn-primary btn-sm px-3"
      onClick={() => handleOverallClick(group.date)}
    >
      Overall
    </button>
  </td>
)}
  </tr>
);
                          });
                        })
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="row mt-3">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First page"
                        >
                          <span aria-hidden="true">««</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous page"
                        >
                          <span aria-hidden="true">«</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next page"
                        >
                          <span aria-hidden="true">»</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last page"
                        >
                          <span aria-hidden="true">»»</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Notification Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="notificationModalLabel"
        aria-hidden={!showModal}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="notificationModalLabel"
              >
                Send {actionType} Request to Admin
              </h6>
              <button
                type="button"
                className="btn-close"
                onClick={closeNotificationModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleNotificationSubmit}>
                <p className="text-center">
                  Do you want to request to {actionType.toLowerCase()} this
                  record?
                </p>
                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm px-4 me-2"
                    onClick={closeNotificationModal}
                    aria-label="Cancel"
                  >
                    No
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    disabled={isSubmitting}
                    aria-label="Submit request"
                  >
                    Yes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{ display: deleteShowModals ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-hidden={!deleteShowModals}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3">Are you sure?</h4>
              <h6 className="mb-4">
                Do you really want to delete the record for
                <span className="text-primary"> {deleteDate}</span>?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                  aria-label="Cancel"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                  aria-label="Delete"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SalesExpense;

/*
  ── ONE-LINE ADDITION NEEDED IN YOUR LAYOUT COMPONENT ──
  Wherever `collapsed`/`toggleSidebar` state lives (the component that
  renders <Sidebar collapsed={...} toggleSidebar={...} .../>), add:

  useEffect(() => {
    const onCollapse = () => setCollapsed(true); // your state setter
    window.addEventListener("app:collapseSidebar", onCollapse);
    return () => window.removeEventListener("app:collapseSidebar", onCollapse);
  }, []);

  That's it — SalesExpense now fires this event right before navigating
  to the txn-overview page, so the sidebar will already be collapsed
  when the new page mounts.
*/